module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cnGzD"))).then(() => parcelRequire('5erN3'));